import {Switch, Trail} from '@yandex-delivery/blocks'
import type {ReactElement} from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import {useFormUserEventHandler} from '../../lib/metrika'
import type {SwitchWidgetProps as Props} from '../types'

export function SwitchWidget({config}: Props): ReactElement {
  const {enabled, metrica_label, name, value} = config
  const {control} = useFormContext()
  const handleReachGoal = useFormUserEventHandler()

  return (
    <Controller
      control={control}
      defaultValue={!value}
      name={name}
      render={({field, fieldState}) => (
        <Trail>
          <Switch
            disabled={!enabled}
            error={fieldState.invalid}
            name={field.name}
            on={field.value}
            onChange={on => {
              metrica_label && handleReachGoal(metrica_label)
              field.onChange(on)
            }}
            size="m"
          />
        </Trail>
      )}
    />
  )
}
